/** Trigram set of a string (space-padded), for Dice-coefficient similarity. */
function trigrams(s: string): Set<string> {
  const t = ` ${s} `;
  const set = new Set<string>();
  for (let i = 0; i < t.length - 2; i++) set.add(t.slice(i, i + 3));
  return set;
}

/** Sørensen–Dice similarity of two strings over their trigrams (0..1). */
export function diceSimilarity(a: string, b: string): number {
  const A = trigrams(a);
  const B = trigrams(b);
  if (A.size === 0 || B.size === 0) return 0;
  let inter = 0;
  for (const g of A) if (B.has(g)) inter++;
  return (2 * inter) / (A.size + B.size);
}

function wordScore(q: string, w: string): number {
  if (w === q) return 1;
  if (w.startsWith(q)) return 0.9;
  if (w.includes(q)) return 0.72;
  return diceSimilarity(q, w);
}

/**
 * Score a query against one index term. Combines exact/prefix/substring boosts
 * on the whole term and on each of its words with a trigram-similarity fallback
 * for typo tolerance. Returns 0..1.
 */
export function scoreTerm(query: string, term: string): number {
  const q = query.toLowerCase().trim();
  const t = term.toLowerCase().trim();
  if (q === "" || t === "") return 0;

  let best = 0;
  if (t === q) best = 1;
  else if (t.startsWith(q)) best = 0.9;
  else if (t.includes(q)) best = 0.72;

  for (const w of t.split(/\s+/)) {
    best = Math.max(best, wordScore(q, w));
    if (best === 1) break;
  }
  return best;
}
